import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'mh-core-lib-view-guests-selector',
    templateUrl: './view-guests-selector.component.html',
    styleUrls: ['./view-guests-selector.component.scss'],
    standalone: false,
    // Host flex: siendo inline, la línea de texto le sumaba ~1 px a la píldora de 36 px y desalineaba la barra
    host: { class: 'tw-flex' },
})
export class CoreLibViewGuestsSelectorComponent {
  @Input() options: string[] = [];
  @Input() selectedType: string;
  @Input() disabled: boolean = false;
  @Input() leftText: string;
  @Input() rightText: string;
  @Input() leftTooltip: string;
  @Input() rightTooltip: string;
  @Output() selectedOption = new EventEmitter<string>();

  handleSelectedOption(option: string) {
    if (this.disabled) { // emit null for disabled value
      this.selectedOption.emit(null);
      return;
    } 
    this.selectedType = option;
    this.selectedOption.emit(option);
  }

  getTooltip(index: number, type: string): string {
    if (index === 0 && this.leftTooltip) {
      return this.leftTooltip;
    }
    if (index === 1 && this.rightTooltip) {
      return this.rightTooltip;
    }
    return 'answer_survey.' + type;
  }
}
